import { redirectToAuth } from "@/router/helpers";
import { TokenNotValidException } from "@/services/user";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const handleInvalidTokenFound = async (route: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  try {
    await checkUserOnInitialPageLoad();
    return next();
  } catch (e: unknown) {
    if (e instanceof TokenNotValidException) {
      return redirectToAuth(route, next);
    } else {
      throw e;
    }
  }
};
